/*
 *  Copyright (c) 2011-2023 Acronis Incorporated. All rights reserved.
 *
 *  This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *  No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('access.Nodes')
    .factory('ShareGroupsResource', [
        '$resource',
        'ShareGroupsInterceptor',
        function (
            $resource,
            ShareGroupsInterceptor
        ) {
            const resource = $resource('/share_groups/:id', {}, {
                query: {
                    method: 'GET',
                    isArray: true,
                    interceptor: ShareGroupsInterceptor,
                    cancellable: true
                },
                save: {
                    method: 'POST',
                    isArray: false,
                    interceptor: ShareGroupsInterceptor,
                    transformRequest: _transformRequest
                },
                update: {
                    method: 'PUT',
                    params: {
                        id: '@uuid',
                    },
                    isArray: false,
                    interceptor: ShareGroupsInterceptor,
                    transformRequest: _transformRequest
                }
            });

            function _transformRequest(shareGroup) {
                return angular.toJson({
                    name: shareGroup.name,
                    description: shareGroup.description
                });
            }

            return resource;
        }]);
